import React from "react";
import ReactDOM from "react-dom";
import Core from "Components/Core";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

import "main.scss";

ReactDOM.render( <Core />, document.getElementById( "root" ) );

unregisterServiceWorker();